<template>
  <div>
    <button
      ref="filterBtn"
      class="  bg-gray-200 rounded-full p-2 text-md flex items-center gap-6"
      @click="togglePanel"
      type="button"
    >
      <span class="
      ">{{ selectedLabel }}</span>
      <i class="fas fa-chevron-down"></i>
    </button>
    <Popover ref="op">
      <ul class="min-w-[180px] py-2 h-44 overflow-scroll">
         <li
            @click="selectOption({ label: title, value: undefined })"
            class="px-4 py-2 hover:bg-gray-100 cursor-pointer font-semibold"
          >
            All
          </li>
        <li
          v-for="option in options"
          :key="option.value"
          @click="selectOption(option)"
          class="px-4 py-2 hover:bg-gray-100 cursor-pointer"
        >
          {{ option.label }}
        </li>
      </ul>
      <div class="pointer-events-none absolute left-0 right-0 bottom-0 h-6 bg-gradient-to-t from-white to-transparent"></div>
    </Popover>
  </div>
</template>

<script setup lang="ts">

interface Option {
  label: string;
  value: string | number | boolean | undefined;
}

const props = defineProps<{
  options: Option[];
  title: string;
  selected?: string | number | boolean;
}>();

const emit = defineEmits(['select']);

const op = ref();

const selectedLabel = computed(() => {
  if (props.selected === undefined || props.selected === null) return props.title;
  const found = props.options.find(opt => opt.value === props.selected);
  return found ? found.label : props.title;
});
function togglePanel(event: Event) {
  op.value.toggle(event);
}

function selectOption(option: Option) {
  emit('select', option.value);
  op.value.hide();
}
</script>
